module.exports = __webpack_public_path__ + "customer-vehicle.d6450608f24ea03f31c95d1d63849600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customer-vehicle.svg
// module id = 1135
// module chunks = 0